import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/HWCLogoDarkMode.png'


const _withScopeId = n => (_pushScopeId("data-v-33b7b232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "local-login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "HotWax Commerce"
  })
], -1))
const _hoisted_3 = { class: "ion-padding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("form", {
              class: "local-login-form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
            }, [
              _hoisted_2,
              (_ctx.errorMessage)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            color: "warning",
                            icon: _ctx.warningOutline
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.translate("Login failed")) + " ", 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: _ctx.translate('OMS'),
                        "label-placement": "fixed",
                        name: "instanceUrl",
                        modelValue: _ctx.instanceUrl,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.instanceUrl) = $event)),
                        type: "text",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: _ctx.translate('Username'),
                        "label-placement": "fixed",
                        name: "username",
                        modelValue: _ctx.username,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
                        type: "text",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { lines: "none" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: _ctx.translate('Password'),
                        "label-placement": "fixed",
                        name: "password",
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                        type: "password",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ion_button, {
                  expand: "block",
                  type: "submit",
                  disabled: _ctx.isLoggingIn
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("Login")) + " ", 1),
                    (_ctx.isLoggingIn)
                      ? (_openBlock(), _createBlock(_component_ion_spinner, {
                          key: 0,
                          slot: "end",
                          name: "crescent"
                        }))
                      : (_openBlock(), _createBlock(_component_ion_icon, {
                          key: 1,
                          slot: "end",
                          icon: _ctx.arrowForwardOutline
                        }, null, 8, ["icon"]))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 32)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}